import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles, manager, teamAdmin } from '../../constants/appConstants';
import { dashboardLoader } from '../loaders/dashboard';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const DashboardPage = lazy(() => import('../../components/pages/dashboard'));

const dashboardPath = '/dashboard' as const;

export const dashboardRoutes = {
	path: dashboardPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<DashboardPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, dashboardData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					dashboardLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...dashboardData,
				};
			},
		},
		{
			path: 'team/:teamId',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<DashboardPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, dashboardData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					dashboardLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...dashboardData,
				};
			},
		},
	],
};
